<template>
  <v-app>
    <v-btn @click.native="err" style='display: none;'>
      error
    </v-btn>
    <template v-if="!authenticated">
      <main>
        <v-container>
          <router-view name="auth"></router-view>
        </v-container>
      </main>
    </template>
    <template v-else>
      <v-navigation-drawer clipped permanent dark :mini-variant="mini">
        <v-list dense class="pt-0">
          <router-link v-if="item.show.indexOf(user.company.type) > -1" :title="item.title" v-for="item in items" :key="item.title" class="list__tile" tag="a" :to="item.route">
            <v-list-tile-action>
              <v-icon style="color: white">
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </router-link>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar fixed class="tender__color">
        <img src="../static/logo.png" alt="" style="max-height: 100%">
        <v-toolbar-side-icon @click.stop="mini = !mini"></v-toolbar-side-icon>
        <v-spacer></v-spacer>
        {{ user.name }} ({{ user.company.name }})
        <v-btn @click="logout">выйти</v-btn>
      </v-toolbar>
      <main>
        <v-container fluid>
          <router-view>
            <!-- loading spinner slot -->
            <v-layout slot="loading" v-if="loading">
              <v-spacer></v-spacer>
              <v-flex xs1 slot="loading">
                <v-progress-circular class="cyan--text lighten-3" indeterminate
                                     v-bind:size="100" v-bind:width="7">
                </v-progress-circular>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
            <!-- -->
          </router-view>
        </v-container>
      </main>
    </template>
    <!-- successMessage -->
    <v-dialog v-model="success.enabled">
      <v-card>
        <v-card-text>
          <v-alert success value="true">
            {{ success.message }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- errorMessage -->
    <v-dialog v-model="error.enabled">
      <v-card>
        <v-card-text>
          <v-alert error value="true">
            {{ error.message }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import * as auth from './auth'
  import axios from './api/axios'

  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        fixed: false,
        mini: false,
        test: true,
        items: [
          {
            icon: 'gavel',
            title: 'Мои тендеры',
            route: {
              name: 'Tenders'
            },
            show: ['shipper']
          },
          {
            icon: 'pan_tool',
            title: 'Участие',
            route: {
              name: 'Participations'
            },
            show: ['shipper', 'carrier']
          },
          {
            icon: 'list',
            title: 'База вопросов',
            route: {
              name: 'QuestionsBase'
            },
            show: ['shipper']
          },
          {
            icon: 'email',
            title: 'Рассылки',
            route: {
              name: 'Mailings'
            },
            show: ['shipper']
          }
        ],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'Tender'
      }
    },
    computed: {
      ...mapGetters({
        'loading': 'loading',
        'user': 'auth/user',
        'success': 'success',
        'error': 'error',
        'authenticated': 'auth/authenticated'
      })
    },
    mounted () {
      if (auth.checkAuth()) {
        this.storeLogin({
          company: auth.tokenPayload('company'),
          name: auth.tokenPayload('name')
        })
      }
      let vm = this
      axios.interceptors.response.use((response) => {
        return response
      }, (error) => {
        if (error) {
          vm.stopLoading(false)
        }
        if (error.response && error.response.status === 401) {
          vm.logout()
        }
        return Promise.reject(error)
      })
    },
    methods: {
      ...mapMutations(['clearSuccessMessage', 'clearErrorMessage', 'successMessage', 'errorMessage', 'stopLoading']),
      ...mapMutations({
        'storeLogin': 'auth/login',
        'storeLogout': 'auth/logout'
      }),
      logout () {
        auth.removeToken()
        this.storeLogout()
        this.$router.push({
          name: 'auth'
        })
      },
      err () {
        throw new Error('testing error')
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'

  .flex {
    margin-bottom: 16px;
  }

  /*div.logo img {
    width: 100%;
  }*/
  .tender__color {
    background-color: #76e4e5 !important;
    border-color: #76e4e5 !important;
  }
</style>



// WEBPACK FOOTER //
// App.vue?22139849